class ScrollableNav extends HTMLElement {
  connectedCallback() {
    this.container = this.querySelector("[data-scroll-container]");
    this.prevBtn = this.querySelector("[data-scroll-prev]");
    this.nextBtn = this.querySelector("[data-scroll-next]");
    if (!this.container) return;
    this.scrollAmount = 200;
    this.container.addEventListener("scroll", () => this.updateArrows(), { passive: true });
    this.prevBtn.addEventListener("click", () => this.scroll(-1));
    this.nextBtn.addEventListener("click", () => this.scroll(1));
    this.resizeObserver = new ResizeObserver(() => this.updateArrows());
    this.resizeObserver.observe(this.container);
    this.updateArrows();
  }
  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }
  scroll(direction) {
    this.container.scrollBy({ left: direction * this.scrollAmount, behavior: "smooth" });
  }
  updateArrows() {
    const { scrollLeft, scrollWidth, clientWidth } = this.container;
    const hasOverflow = scrollWidth > clientWidth;
    const atStart = scrollLeft <= 0;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;
    this.toggleArrow(this.prevBtn, hasOverflow && !atStart);
    this.toggleArrow(this.nextBtn, hasOverflow && !atEnd);
  }
  toggleArrow(btn, visible) {
    btn.classList.toggle("opacity-0", !visible);
    btn.classList.toggle("pointer-events-none", !visible);
    btn.classList.toggle("pointer-events-auto", visible);
    btn.classList.toggle("cursor-pointer", visible);
  }
}
window.customElements.define("scrollable-nav", ScrollableNav);
